import React from 'react';
import config from '~/config';

/**
 * @param {import('react').PropsWithChildren} props The props of the component.
 */
const DevOnlyWrapper = (props) => <React.Fragment>{config.Environment === 'DEV' && props.children}</React.Fragment>;

export default DevOnlyWrapper;
